import React from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import VTBuyDance from "../page/VTBuyDance";

export default function LandingBuyDance() {
    return (
        <>
            <Header headerType="UserOnly"/>
            <VTBuyDance/>
            <Footer/>
        </>
    );
}